import React from 'react';
import Modal from '../../common/Modal';
import FormField from '../../common/FormField';
import { useFormData } from '../../../hooks/useFormData';

/**
 * Category add/edit modal.
 * Before: 107 lines with duplicate style objects.  After: ~25 lines.
 */

const DEFAULTS = { category_id: '', category_name: '' };

export default function CategoryModal({ isOpen, onClose, onSubmit, initialData, title }) {
  const { formData, handleChange } = useFormData(DEFAULTS, initialData, isOpen);

  return (
    <Modal isOpen={isOpen} onClose={onClose} onSubmit={() => onSubmit(formData)} title={title}>
      <FormField
        name="category_name"
        label="Category Name"
        value={formData.category_name}
        onChange={handleChange}
        required
      />
    </Modal>
  );
}
